module.exports = __webpack_public_path__ + "img/game-3@2x.5fae0e60.png";